import React, { useState } from 'react';
import './NotificationFilter.css';

const NotificationFilter = ({ filters, onFilterChange }) => {
  const [dateFrom, setDateFrom] = useState(filters.dateFrom || '');
  const [dateTo, setDateTo] = useState(filters.dateTo || '');
  
  const handleApplyFilter = () => {
    onFilterChange({
      dateFrom,
      dateTo
    });
  };
  
  return (
    <div className="notification-filter">
      <div className="filter-group">
        <label>Fecha desde</label>
        <input
          type="date"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
        />
      </div>
      
      <div className="filter-group">
        <label>Fecha hasta</label>
        <input
          type="date"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
        />
      </div>
      
      <button 
        className="apply-filter-button"
        onClick={handleApplyFilter}
      >
        Aplicar filtro
      </button>
    </div>
  );
};

export default NotificationFilter;